import { SvgIcon } from '@mui/material';

const WarningDialogIcon = (props) => (
    <SvgIcon sx={{ width: 48, height: 48 }}  {...props} viewBox="0 0 49 48">
        <rect width="48" height="48" x="0.5" fill="#F9CF86" fillOpacity="0.12" rx="16" />
        <path
            fill="#FFC259"
            d="m25.799 15.148 8.634 14.954a1.5 1.5 0 0 1-1.299 2.25H15.866a1.5 1.5 0 0 1-1.299-2.25l8.634-14.954c.577-1 2.02-1 2.598 0M24.5 27a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-7a1 1 0 0 0-.993.883L23.5 21v4a1 1 0 0 0 1.993.117L25.5 25v-4a1 1 0 0 0-1-1"
        />
    </SvgIcon>
);

export default WarningDialogIcon;